import getUser from './getUser';

function loadKilkaya() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const isApp = urlParams.has('ismobileapp');
  const platform = isApp ? 'app' : window.innerWidth < 500 ? 'moblie' : 'desktop';

  const user = getUser();
  window.k5aMeta = {
    ...window.k5aMeta,
    login: typeof window === 'undefined' ? false : user.type !== 'anonymous',
    subscriber: typeof window === 'undefined' ? false : user.type === 'paying',
    referer: typeof document === 'undefined' ? undefined : document.referrer,
    channel: platform,

  };
  const script = document.createElement('script');
  script.src = 'https://cl-eu6.k5a.io/668e5a53d83b2f4bdb79db32.js';
  script.id = 'kilkaya';
  script.defer = true;
  document.head.appendChild(script);
}

export default loadKilkaya;
